import { render, staticRenderFns } from "./BoardLeft.vue?vue&type=template&id=d9cc4046&scoped=true&"
import script from "./BoardLeft.vue?vue&type=script&lang=js&"
export * from "./BoardLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cc4046",
  null
  
)

export default component.exports